import React from 'react';
import { Link } from 'react-router-dom';
import CategoryNav from './CategoryNav';

function MobileNav({ open, onClose }) {
    return (
        <nav
            className={`mobile-nav-overlay${open ? ' open' : ''}`}
            id="mobile-nav"
            aria-label="Mobile navigation"
        >
            <div className="mobile-nav-close">
                <button type="button" id="mobile-close-btn" aria-label="Close menu" onClick={onClose}>
                    CLOSE ✕
                </button>
            </div>
            <div style={{ padding: '1rem 0' }}>
                <nav className="mobile-nav-links" aria-label="Pages">
                    <Link to="/" onClick={onClose}>Home</Link>
                    <Link to="/about" onClick={onClose}>About</Link>
                    <Link to="/videos" onClick={onClose}>Video — Condoned Media</Link>
                    <Link to="/tags" onClick={onClose}>Tag Index</Link>
                    <Link to="/old?portal=1" onClick={onClose}>Author Portal</Link>
                </nav>
                <CategoryNav onNavigate={onClose} />
            </div>
        </nav>
    );
}

export default MobileNav;
